import React, { Component } from 'react';
import { connect } from "react-redux";
import ReactDOM from 'react-dom';
import { fetchCasos, fetchUser, fetchComments, removeCaso} from '../../../actions';
import { Link } from 'react-router-dom';
import { TransitionGroup, Transition } from 'react-transition-group';
import anime from 'animejs';
import _ from 'lodash';

import {
    Card,
    CardBlock,
    CardHeader
} from 'reactstrap';
import CasoBox from '../../dashboard/CasoBox';
import CommentBox from '../../dashboard/CommentBox';
import LastComments from '../../dashboard/LastComments';

class Dashboard extends Component {
    componentDidMount() {
        this.props.fetchCasos(null, null, null, null, null, null, null, 'dashboard');
        this.props.fetchComments();
        this.animateIn(ReactDOM.findDOMNode(this))
    }
    removeCaso(caso){
        this.props.removeCaso(caso);
    }
    renderCasos(){
        if(_.isEmpty(this.props.casos)){
            return(<div className="chat-nomessages"><i className="fa fa-archive fa-5x"></i>No  tiene casos pendientes</div>)
        }
        return this.props.casos.map((caso) => {
            return (
                <CasoBox key={caso.id} caso={caso} removeCaso={() => this.removeCaso(caso.id)}  />
            );
        })

    }
    renderComments(){
        if(_.isEmpty(this.props.comments)){
            return(<div className="chat-nomessages"><i className="fa fa-comments fa-5x"></i>Aún no se ha enviado ningún mensaje</div>)
        }
        return this.props.comments.map((comment) => {
            return (
                <CommentBox
                    key={comment.id}
                    text={comment.text}
                    casoId={comment.caso_id}
                    commentId={comment.id}
                    updatedAt={comment.updated_at}
                    caso={comment.caso_title}
                />
            );
        })
    }
    animateIn = (gridContainer) => {
        anime.timeline()
            .add({
                targets: gridContainer.querySelectorAll('div.col-4'),
                duration: 500,
                opacity: [0, 1],
                translateY: [-30, 0],
                easing: 'easeInOutSine'
            })
            .add({
                targets: gridContainer.querySelectorAll('.tableContainer'),
                duration: 500,
                opacity: [0, 1],
                translateY: [-30, 0]
            })
    }
    render(){
        return(
            <div className="row dashboard-container">
                <div className="col-6">
                    <Card>
                        <CardHeader>
                            <i className="fa fa-line-chart text-white" /> Última actividad
                        </CardHeader>
                        <CardBlock>
                            <div className="tableContainer">
                                {this.renderCasos()}
                            </div>
                        </CardBlock>
                    </Card>
                </div>
                <div className="col-6">
                    <Card>
                        <CardHeader>
                            <i className="fa fa-commenting text-white" /> Comentarios pendientes
                        </CardHeader>
                        <CardBlock>
                            <div className="tableContainer">
                                {this.renderComments()}
                            </div>
                        </CardBlock>
                    </Card>
                </div>
            </div>
        );
    }
}
function mapStateToProps(state) {
    return {
        casos: state.casos.data,
        comments: state.comments
    };
}
export default connect(mapStateToProps, { fetchCasos, fetchComments, removeCaso })(Dashboard);


// WEBPACK FOOTER //
// ./resources/assets/js/components/admin/dashboard/Dashboard.jsx